
import { useState, useEffect } from 'react';
import { generateMockMonthlyReport } from '@/utils/mockData';

export const useReportData = (month?: string, year?: string) => {
  const [data, setData] = useState<any>({});
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // In a real app, this would call an API with the month and year
        // For now, just use mock data
        const mockReport = generateMockMonthlyReport();
        setData(mockReport);
      } catch (error) {
        console.error('Error fetching report data:', error);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchData();
  }, []);
  
  return {
    data: data?.data || [],
    chartData: data?.chartData || [],
    isLoading
  };
};
